import { scaleOrdinal, ScaleOrdinal } from 'd3-scale';

import { colors } from './';
import { Risk } from '../types';
import { risks } from '../enums';

type ColorStyles = (
  colorAttribute: string,
  selectorPrefix?: string,
  selectorSuffix?: string,
) => string;

const ColorStylesFactory: (scale: any) => ColorStyles = scale => {
  return (attr, prefix = '', suffix = '') => {
    return risks
      .map(risk => {
        return `${prefix}.risk-${risk} ${suffix} {
        ${attr}: ${scale(risk)};
      };`;
      })
      .join();
  };
};

export const primaryRiskColors = [
  colors.red500,
  colors.orange500,
  colors.green500,
  colors.green500,
];

export const secondaryRiskColors = [
  colors.red100,
  colors.orange100,
  colors.green100,
  colors.green100,
];

export const primaryRiskColorScale = scaleOrdinal<Risk, string>()
  .domain(risks)
  .range(primaryRiskColors);

export const secondaryRiskColorScale = scaleOrdinal<Risk, string>()
  .domain(risks)
  .range(secondaryRiskColors);

export const primaryRiskColorStyles = ColorStylesFactory(primaryRiskColorScale);

export const secondaryRiskColorStyles = ColorStylesFactory(
  secondaryRiskColorScale,
);
